
import { Facet } from '../models/Facet';

/**
 * Represents a single thumbnail available for an item.
 */
export const thumbnailFacet = new Facet<{
  width: number;
  height: number;
  url: string;
}>('thumbnail');

/**
 * Represents the dimensions of a media item or single thumbnail.
 */
export const dimensionsFacet = new Facet<{
  width: number;
  height: number;
}>('dimensions');

/**
 * Represents an item which has photo metadata.
 */
export const photoFacet = new Facet<{}>('photo');

/**
 * Represents an item which has video metadata.
 */
export const videoFacet = new Facet<{}>('video');
